import React, { useEffect, useState } from 'react';
import scrollIntoView from 'scroll-into-view-if-needed';

import { cn } from '@lyearn/style';
import { Input } from '@lyearn/ui';

import { EditableTextWebProps } from './types';
import useEditableTextProps from './useEditableTextProps';

const EditableTextWeb: React.FC<EditableTextWebProps> = (props) => {
  const { name, onAction, className, inputProps, variant } = props;
  const [newName, setNewName] = useState(name);
  const [inputRef, setInputRef] = useState<HTMLDivElement | null>(null);

  const { onChange, onKeyUp, saveName } = useEditableTextProps(name, onAction, setNewName);

  const onClick = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    e.preventDefault();
    e.stopPropagation();
  };

  useEffect(() => {
    inputRef?.querySelector('input')?.select();
    inputRef &&
      scrollIntoView(inputRef, {
        behavior: 'smooth',
        scrollMode: 'if-needed',
        block: 'center',
        inline: 'nearest',
      });
  }, [inputRef]);

  return (
    <Input
      ref={setInputRef}
      className={cn('h-full w-full bg-bg-primary', className)}
      inputProps={inputProps}
      value={newName}
      variant={variant}
      onBlur={() => saveName(newName)}
      onChange={onChange}
      onClick={onClick}
      onKeyUp={(e) => onKeyUp(e, newName)}
    />
  );
};

export default EditableTextWeb;
